export const AllergenTypeEnum = {
    ORDER: 'order',
    DISH: 'dish',
};
